var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",class:_vm.cssClasses,on:{"click":_vm.onClick}},[_c('span',[_vm._t("default",function(){return [_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")]})],2),_vm._v(" "),_c('a-icon',{staticClass:"expandable-icon",attrs:{"type":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }